{
  "commonHeader": {
    "upgradeToPro": "Upgrade",
    "learnMore": "Mehr erfahren",
    "AIProductivitySuite": {
      "title": "KI-Produktivitätssuite",
      "desc": "Verwandeln Sie inspirierende Diskussionen in beeindruckende Ergebnisse."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Das Konto Ihrer Organisation mit KI verwalten",
        "description": "Erhalten Sie intelligente Antworten auf Ihre Kontofragen und Hilfe beim Navigieren in den Einstellungen.",
        "terms": "Durch die Nutzung der Beta-Funktionen von Zoom stimmen Sie {0} zu",
        "termsText": "den Bedingungen des Zoom-Beta-Programms"
      },
      "diveDeeper": "Mehr erfahren",
      "shareFeedback": "Feedback teilen in {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Fragen Sie zum Konto Ihrer Organisation",
      "heroInvite": "Wie lade ich einen neuen Benutzer zu meinem Konto ein?",
      "heroGroups": "Wie weise ich Benutzer Gruppen zu?",
      "heroRoles": "Wie verwalte ich Rollen und Berechtigungen?"
    },
    "backMainAccount": "Zurück zum Hauptkonto",
    "discoverProducts": "Produkte entdecken",
    "pricing": "Preise",
    "more": "Mehr",
    "sidebarExpanded": "erweitert",
    "sidebarCollapsed": "reduziert",
    "search": "Suchen",
    "users": "Benutzer",
    "settings": "Kontoeinstellungen",
    "navigation": "Navigation",
    "clear": "Löschen",
    "searchPlaceholderAll": "Nach Benutzern, Kontoeinstellungen oder Navigation suchen",
    "searchPlaceholderUsers": "Nach Benutzern oder Navigation suchen",
    "searchPlaceholderSettings": "Nach Kontoeinstellungen oder Navigation suchen",
    "searchPlaceholderNav": "Nach Navigation suchen",
    "searchGuide": "Geben Sie Schlüsselwörter ein, um die Suche zu starten",
    "installOnDesktop": "Auf dem Desktop installieren",
    "downloadCenter": "Download-Center",
    "getInTouch": "Kontakt aufnehmen",
    "featuredProduct": "vorgestelltes Produkt",
    "logo": {
      "adminCenter": "Admin-Center",
      "subAccount": "Unterkonto wird verwaltet",
      "externalAccount": "Delegiertes Konto wird verwaltet"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Mehr erfahren",
      "gotIt": "Verstanden"
    },
    "coachMark": {
      "dvsTipsTitle": "Divisionen sind jetzt verfügbar",
      "dvsTipsContent": "Mit Divisionen können Sie in Ihrem Konto mehrere Instanzen bestimmter Zoom-Produkte erstellen."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Mehr erfahren",
      "gotIt": "Verstanden"
    },
    "coachMark": {
      "extAccountTipsTitle": "Externe Konten verwalten",
      "extAccountTipsContent": "Müssen Sie ein anderes Konto verwalten? Senden Sie einfach eine Anfrage – nach der Genehmigung können Sie loslegen!"
    }
  },
  "feedback": {
    "dialogTitle": "Feedback geben",
    "itemLableForProductArea": "Produktbereich",
    "itemLableForSatisfied": "Wie zufrieden sind Sie mit der Verwendung?",
    "dissatisfied": "Sehr unzufrieden",
    "satisfied": "Sehr zufrieden",
    "itemLableForFeedback": "Feedback",
    "placeholder": "Zoom freut sich über Ihre Ideen, Kommentare und Vorschläge.",
    "btnCancel": "Abbrechen",
    "btnSubmit": "Absenden",
    "supportTips": "Technischen Support finden Sie unter",
    "btnSupport": "Support.",
    "messages": {
      "success": "Vielen Dank für Ihr Feedback!",
      "productFailed": "Produktbereich ist erforderlich.",
      "scoreFailed": "Zufriedenheitswert ist erforderlich."
    },
    "products": {
      "General": "Allgemein",
      "AI": "KI",
      "Apps": "Apps",
      "Calendar": "Kalender",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Meetings",
      "Notes": "Notizen",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Scheduler",
      "Tasks": "Aufgaben",
      "TeamChat": "Team Chat",
      "WebinarsAndEvents": "Webinare und Events",
      "Whiteboard": "Whiteboard",
      "WorkflowAutomations": "Workflow-Automatisierungen",
      "WorkspaceReservation": "Arbeitsplatzreservierung",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Dieser Rechtshinweis wurde vom Kontoadministrator erstellt.",
    "cancel": "Abbrechen",
    "agree": "Einverstanden"
  },
  "shared": {
    "sideMenu": {
      "personal": "Persönlich",
      "admin": "Admin",
      "menu": "Menü",
      "pinned": "Angeheftet",
      "pin": "Anheften",
      "unpin": "Losheften",
      "moveItem": "Element verschieben",
      "myAccount": "Mein Konto",
      "upgradeToPro": "Auf Pro upgraden",
      "grabbedKeyboard": "{0} gegriffen. Mit den Pfeiltasten nach oben und unten verschieben, Leertaste oder Eingabe zum Ablegen.",
      "dropped": "{0} abgelegt.",
      "releasedUnchanged": "{0} losgelassen, Position unverändert.",
      "movedToPosition": "{0} an Position {1} von {2} verschoben.",
      "movedUp": "{0} nach oben verschoben, Position {1} von {2}.",
      "movedDown": "{0} nach unten verschoben, Position {1} von {2}.",
      "movedUpNew": "{0} nach oben verschoben, neue Position {1} von {2}",
      "movedDownNew": "{0} nach unten verschoben, neue Position {1} von {2}",
      "cannotMoveFurther": "{0} kann nicht weiter verschoben werden.",
      "grabbedMouse": "{0} gegriffen. Maus zum Neupositionieren bewegen, klicken zum Ablegen, Escape zum Abbrechen."
    },
    "item": "Element",
    "gotIt": "Verstanden",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Telefonnummer hinzugefügt! Sie kann jetzt für zukünftige Anmeldungen und Kontowiederherstellungen verwendet werden.",
    "mfa_to_signin_phone_success": "{phone} ist jetzt die Anmeldenummer für {email}.",
    "login_passkey_bound_success": "Passkey erfolgreich erstellt"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Die folgenden erweiterten Verwaltungsfunktionen gelten nur für lizenzierte Benutzer und Kollaborationsbenutzer",
      "licensed_basic": "Die folgenden erweiterten Verwaltungsfunktionen gelten nur für lizenzierte und Basic-Benutzer",
      "licensed": "Die folgenden erweiterten Verwaltungsfunktionen gelten nur für lizenzierte Benutzer"
    },
    "support": "– Wird in den Kontoeinstellungen und Benutzergruppeneinstellungen unterstützt",
    "archive_product": {
      "title": "Meetings und Webinare archivieren",
      "detail": "– Meetings werden archiviert, wenn Benutzer in Ihrem Konto beitreten. Installieren Sie eine <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">Archivierungs-App</a> aus dem Zoom App Marketplace, um diese Funktion zu verwenden."
    },
    "restrict": {
      "title": "Die Nutzung ausgewählter Funktionen für Benutzer einschränken, wenn sie an einem Meeting teilnehmen",
      "detail": "– Ausgewählte Funktionen können nicht genutzt werden, selbst wenn Meeting-Hosts diese für Meetings aktivieren."
    },
    "meeting_integration": {
      "title": "DLP (Data Loss Prevention) für Meeting-Chat aktivieren",
      "detail": "– Bei Aktivierung dieser Option gilt DLP sowohl für öffentliche als auch für private Chatnachrichten, die ein Teilnehmer sendet. Die Nachrichten werden sofort gelöscht, wenn Teilnehmer in einem Meeting (intern/extern) chatten und eine Nachricht gegen die Compliance-Richtlinien der Hostorganisation verstößt."
    },
    "chat_tool": {
      "title": "Chat-Etikette-Tool",
      "detail": "Identifizieren Sie definierte Schlüsselwörter und Textmuster in freigegebenen Inhalten, und verhindern Sie, dass Benutzer unerwünschte Nachrichten teilen."
    },
    "information_barriers": {
      "title": "Informationssperren",
      "detail": "– Informationsbarrieren regeln die Kommunikation zwischen bestimmten Benutzern im Sinne der Richtlinienerfüllung. Beschränkungen für Meetings und Chats können zwischen Benutzern in zwei Gruppen angeordnet werden und bestimmte Benutzer können bestimmte Funktionen nicht nutzen (z. B. für den Chat im Meeting, die Bildschirmfreigabe und die Dateiübertragung). Mit diesen Einschränkungen wird verhindert, dass vertrauliche Angaben zwischen unbefugten Benutzern ausgetauscht werden."
    },
    "dashboard": {
      "title": "Dashboard",
      "detail": "– Im Dashboard für Meetings > vergangene Meetings werden die Daten für manche Benutzer nur für einen Zeitraum von drei Monaten angezeigt."
    },
    "reports": {
      "title": "Berichte",
      "detail": "– Bei manchen Berichten werden die Daten für einige Benutzer nur für einen Zeitraum von 3 Monaten angezeigt: Haftungsausschlussbericht, Teilnehmerprotokollbericht, Bericht zu Administratoraktivitätsprotokollen und Bericht zu An- und Abmeldungen"
    },
    "close": "Schließen"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Ihr {planName} wird am {cancelDate} gekündigt. Sie können Ihre Webinar-Lizenzen bis zu diesem Datum reaktivieren. Von {supportStartDate}–{supportEndDate} können Sie sich an den Kundensupport wenden, um Daten bestehender Webinare zu erhalten. Nach dem {dataLossDate} gehen alle Webinar-Daten verloren.",
            "nonAdmin": "Ihr {planName} wird am {cancelDate} gekündigt. Bis zu diesem Datum können Sie sich an Ihren Kontoadministrator wenden, um Ihre Webinar-Lizenzen zu reaktivieren. Von {supportStartDate}–{supportEndDate} können Sie sich an den Kundensupport wenden, um Daten bestehender Webinare zu erhalten. Nach dem {dataLossDate} verlieren Sie alle Webinar-Daten Ihres Kontos."
          },
          "admin": "Ihr {planName} wird am {cancelDate} gekündigt. Sie können Ihre Webinar-Lizenzen bis zu diesem Datum reaktivieren. Von {supportStartDate}–{supportEndDate} können Sie sich an den Kundensupport wenden, um {supportContent} bestehender Webinare zu erhalten. Nach dem {dataLossDate} verlieren Sie alle Webinar-Daten Ihres Kontos.",
          "nonAdmin": "Ihr {planName} wird am {cancelDate} gekündigt. Bis zu diesem Datum können Sie sich an Ihren Kontoadministrator wenden, um Ihre Webinar-Lizenzen zu reaktivieren. Von {supportStartDate}–{supportEndDate} können Sie sich an den Kundensupport wenden, um {supportContent} bestehender Webinare zu erhalten. Nach dem {dataLossDate} verlieren Sie alle Webinar-Daten Ihres Kontos."
        },
        "expired": {
          "admin": "Ihr {planName} wurde gekündigt. Von {supportStartDate}–{supportEndDate} können Sie sich an den Kundensupport wenden, um {supportContent} Ihrer bestehenden Webinare zu erhalten, oder Zoom Webinars erneut erwerben, um den Datenzugriff wiederherzustellen. Nach dem {dataLossDate} verlieren Sie alle Webinar-Daten Ihres Kontos.",
          "nonAdmin": "Ihr {planName} wurde gekündigt. Von {supportStartDate}–{supportEndDate} können Sie den Kundensupport kontaktieren, um die {supportContent} bestehender Webinare zu erhalten, oder den Kontoadministrator kontaktieren, um Zoom Webinars erneut zu erwerben und den Datenzugriff wiederherzustellen. Nach dem {dataLossDate} verlieren Sie alle Webinar-Daten Ihres Kontos."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Ihr {planName} wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare und deren Inhalte ansehen. Sie können Ihre Pause jederzeit aufheben und das Abonnement Ihrer Webinar-Lizenzen wieder aktivieren.",
            "nonAdmin": "Ihr {planName} wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare und deren Inhalte ansehen. Sie können jederzeit Ihren Kontoadministrator kontaktieren, um Ihre Pause zu beenden und das Abonnement Ihrer Webinar-Lizenzen wieder zu aktivieren."
          },
          "admin": "Ihr {planName} wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur {supportContent} anzeigen. Sie können Ihre Pause jederzeit aufheben und das Abonnement Ihrer Webinar-Lizenzen wieder aktivieren.",
          "nonAdmin": "Ihr {planName} wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur {supportContent} anzeigen. Sie können jederzeit Ihren Kontoadministrator kontaktieren, um Ihre Pause zu beenden und das Abonnement Ihrer Webinar-Lizenzen wieder zu aktivieren."
        },
        "active": {
          "webinars": {
            "admin": "Ihr {planName} ist ab dem {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare ansehen. Sie können das Abonnement für Ihre Webinar-Lizenzen jederzeit wieder aktivieren.",
            "nonAdmin": "Ihr {planName} ist ab dem {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare ansehen. Sie können sich jederzeit an Ihren Kontoadministrator wenden, um das Abonnement Ihrer Webinar-Lizenzen wieder zu aktivieren."
          },
          "admin": "Ihr {planName} ist für {pauseDuration} pausiert. Während der Pause können Sie nur die {supportContent} bestehender Webinare ansehen. Sie können das Abonnement für Ihre Webinar-Lizenzen jederzeit wieder aktivieren.",
          "nonAdmin": "Ihr {planName} ist für {pauseDuration} pausiert. Während der Pause können Sie nur die {supportContent} bestehender Webinare ansehen. Sie können sich jederzeit an Ihren Kontoadministrator wenden, um das Abonnement Ihrer Webinar-Lizenzen wieder zu aktivieren."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Ihre {planName}-Lizenz wird am {pausedDate} für {pauseDuration} pausiert. Um weiterhin Webinare hosten zu können, weisen Sie diesem Benutzer eine aktive Lizenz zu, bevor die Pause in Kraft tritt. Sie können die Pause auch aufheben, um diese Lizenz weiterhin zu nutzen.",
            "nonAdmin": "Ihre {planName}-Lizenz wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare und deren Objekte ansehen. Um weiterhin Webinare veranstalten zu können, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihrem Konto eine aktive Lizenz zuzuweisen, bevor die Pause wirksam wird."
          },
          "active": {
            "admin": "Ihre {planName}-Lizenz ist ab dem {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare ansehen. Sie können das Lizenzabonnement jederzeit wieder aktivieren oder Ihrem Konto eine aktive Lizenz zuweisen, um weiterhin Webinare zu hosten.",
            "nonAdmin": "Ihre {planName}-Lizenz ist ab dem {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die bestehenden Webinare ansehen. Um während der Pause Webinare zu hosten, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihrem Konto eine aktive Lizenz zuzuweisen."
          }
        },
        "cancel": {
          "active": {
            "admin": "Ihre {planName}-Lizenz wird am {cancelDate} gekündigt. Um weiterhin Webinare zu hosten, reaktivieren Sie bitte Ihre Webinar-Lizenz oder weisen Sie eine aktive Lizenz zu, bevor die Kündigung wirksam wird. Wenn keine Maßnahme ergriffen wird, haben Sie von {supportStartDate}–{supportEndDate} eine Nachfrist, um den Kundensupport zu kontaktieren und Ihre bestehenden Webinar-Daten abzurufen. Nach dem {dataLossDate} werden alle mit Ihrem Konto verknüpften Webinar-Daten dauerhaft gelöscht.",
            "nonAdmin": "Ihre {planName}-Lizenz wird am {cancelDate} gekündigt. Um weiterhin Webinare zu hosten, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihre Webinar-Lizenz zu reaktivieren oder eine aktive Lizenz zuzuweisen, bevor die Kündigung wirksam wird. Wenn keine Maßnahme ergriffen wird, haben Sie von {supportStartDate}–{supportEndDate} eine Nachfrist, um den Kundensupport zu kontaktieren und Ihre bestehenden Webinar-Daten abzurufen. Nach dem {dataLossDate} werden alle mit Ihrem Konto verknüpften Webinar-Daten dauerhaft gelöscht."
          },
          "expired": {
            "admin": "Ihre {planName}-Lizenz wurde gekündigt. Um weiterhin Webinare zu hosten, weisen Sie diesem Benutzer eine aktive Lizenz zu. Von {supportStartDate} bis {supportEndDate} können Sie sich an den Kundensupport wenden, um bestehende Webinardaten abzurufen.",
            "nonAdmin": "Ihre {planName}-Lizenz wurde gekündigt. Um weiterhin Webinare zu hosten, wenden Sie sich bitte an Ihren Kontoadministrator, damit dieser Ihrem Profil eine aktive Lizenz zuweist. Wenden Sie sich von {supportStartDate} bis {supportEndDate} an den Kundensupport, um bestehende Webinardaten abzurufen."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Ihre {planName}-Lizenz wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die {supportContent} früherer Webinare ansehen. Um weiterhin auf Webinar-Objekte zuzugreifen, weisen Sie diesem Benutzer eine aktive Lizenz zu, bevor die Pause wirksam wird. Sie können die Pause auch aufheben, um diese Lizenz weiterhin zu nutzen.",
              "nonAdmin": "Ihre {planName}-Lizenz wird am {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur {supportContent} anzeigen. Um weiterhin auf Webinar-Objekte zugreifen zu können, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihrem Konto eine aktive Lizenz zuzuweisen."
            },
            "active": {
              "admin": "Ihre {planName}-Lizenz ist ab dem {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die {supportContent} bestehender Webinare ansehen. Um weiterhin auf Webinar-Objekte zugreifen zu können, weisen Sie Ihrem Konto bitte eine aktive Lizenz zu. Sie können dieses Lizenzabonnement auch jederzeit wieder aktivieren.",
              "nonAdmin": "Ihre {planName}-Lizenz ist ab dem {pausedDate} für {pauseDuration} pausiert. Während der Pause können Sie nur die {supportContent} bestehender Webinare ansehen. Um während der Pause Webinare zu hosten, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihrem Konto eine aktive Lizenz zuzuweisen."
            }
          },
          "cancel": {
            "active": {
              "admin": "Ihr {planName} wird am {cancelDate} gekündigt. Um weiterhin Webinare zu hosten, weisen Sie Ihrem Konto bitte eine aktive Lizenz zu, bevor die Kündigung wirksam wird. Sie können diese Lizenz vor {cancelDate} reaktivieren. Vom {supportStartDate} bis {supportEndDate} können Sie sich an den Kundensupport wenden, um {supportContent} bestehender Webinare abzurufen.",
              "nonAdmin": "Ihre {planName}-Lizenz wird am {cancelDate} gekündigt. Um weiterhin Webinare zu hosten, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihre Webinar-Lizenz zu reaktivieren oder eine aktive Lizenz zuzuweisen, bevor die Kündigung wirksam wird. Wenn keine Maßnahme ergriffen wird, haben Sie von {supportStartDate}–{supportEndDate} eine Nachfrist, um den Kundensupport zu kontaktieren und {supportContent} Ihrer bestehenden Webinare abzurufen. Nach dem {dataLossDate} werden alle mit Ihrem Konto verknüpften Webinar-Daten dauerhaft gelöscht."
            },
            "expired": {
              "admin": "Ihre {planName}-Lizenz wurde gekündigt. Um weiterhin Webinare zu hosten, weisen Sie diesem Benutzer eine aktive Lizenz zu. Wenden Sie sich von {supportStartDate} bis {supportEndDate} an den Kundensupport, um {supportContent} bestehender Webinare abzurufen.",
              "nonAdmin": "Ihre {planName}-Lizenz wurde gekündigt. Um weiterhin Webinare zu hosten, wenden Sie sich bitte an Ihren Kontoadministrator, um Ihrem Konto eine aktive Lizenz zuzuweisen. Wenden Sie sich von {supportStartDate} bis {supportEndDate} an den Kundensupport, um {supportContent} bestehender Webinare abzurufen."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "Daten",
        "recordingsAndTranscripts": "Aufzeichnungen und Transkripte",
        "reports": "Berichte",
        "summaries": "Zusammenfassungen",
        "dashboard": "Dashboards"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "Aufzeichnungen und Transkripte vorheriger Webinare",
          "reports": "Berichte über vorherige Webinare",
          "summaries": "Zusammenfassungen vergangener Webinare",
          "dashboard": "Dashboards vorheriger Webinare",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Plan reaktivieren",
    "purchasePlan": "Abo erwerben",
    "removePause": "Pause beenden",
    "resumeSubscription": "Abonnement erneut aktivieren",
    "month": "Monat",
    "months": "Monate",
    "assignLicense": "Lizenz zuweisen"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Verstanden"
    },
    "coachMark": {
      "tipsTitle": "Adressbuch wird zu Kundenverzeichnis",
      "tipsContent": "Im Release vom Oktober 2026 benennen wir das Adressbuch in Kundenverzeichnis um, um den Zweck besser widerzuspiegeln. Alle bestehenden Funktionen, Berechtigungen und Workflows bleiben gleich – Sie verwalten Kundenlisten (Adressbücher) und Kontakte weiterhin wie bisher."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Wir aktualisieren unsere Bedingungen und Richtlinien",
    "agreeSub": "Zur weiteren Nutzung von Zoom erklären Sie sich mit den aktualisierten <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Nutzungsbedingungen</a> und <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Datenschutzrichtlinien</a> einverstanden.",
    "continue": "Fortfahren"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Zurück zum Hauptkonto",
      "backLinkedAccount": "Zurück zum verknüpften Konto",
      "backMyAccount": "Zurück zu Mein Konto",
      "myAccount": "Mein Konto"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion ist jetzt für Ihr Konto verfügbar",
      "desc": "Hier sind einige Custom AI Companion-Funktionen, die Sie in Ihrem Konto nutzen können:",
      "studioTitle": "AI Studio",
      "studioDesc": "Passen Sie die AI Companion-Erfahrung an Ihre Organisation an.",
      "integrationsTitle": "Integrationen von Drittanbietern",
      "integrationsDesc": "Nutzen Sie Apps von Drittanbietern, um Ihre Workflows zu vereinfachen.",
      "clipsTitle": "Benutzerdefinierte Avatare für Zoom Clips",
      "clipsDesc": "Ermöglichen Sie Benutzern, KI-Avatare für ihre Clips zu personalisieren."
    },
    "coachMark": {
      "licenseTitle": "Sie haben {0} Custom AI Companion-Lizenzen zuzuweisen",
      "licenseDesc": "Weisen Sie diese Lizenzen unter <b>Benutzerverwaltung</b> zu, damit Ihre Benutzer erweiterte AI Companion-Funktionen nutzen können.",
      "settingTitle": "Custom AI Companion-Einstellungen für Ihr Konto ansehen",
      "settingDesc": "Konfigurieren Sie die Einstellungen für jede Custom AI-Funktion unter <b>Kontoeinstellungen</b>. <a href=\"/account/setting?tab=aicompanion\">Zu den Einstellungen</a>",
      "groupSettingTitle": "Custom AI-Einstellungen für Ihre Gruppe ansehen",
      "groupSettingDesc": "Konfigurieren Sie die Einstellungen für jede Custom AI-Funktion unter <b>Gruppeneinstellungen</b>. <a href=\"/account/group\">Zu den Einstellungen</a>"
    },
    "common": {
      "learnMore": "Mehr erfahren",
      "quickTour": "Kurztour starten",
      "remindLater": "Später erinnern",
      "dismiss": "Schließen",
      "next": "Weiter",
      "back": "Zurück",
      "gotIt": "Verstanden",
      "goToSetting": "Zu den Einstellungen"
    },
    "aiPanelToast": "Aktivieren Sie die Einstellung <b>KI-Bereich in Zoom Workplace</b>, um alle Custom AI Companion-Funktionen zu nutzen."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Verstanden",
      "next": "Weiter",
      "remindMeLater": "Später erinnern",
      "waffleMenuTitle": "Willkommen bei der neuen Zoom-Weboberfläche",
      "waffleMenuDesc": "Greifen Sie von überall auf Zoom-Produkte zu – mit unserem neuen <b>Produktmenü.</b>",
      "profileMenuTitle": "Mein Konto",
      "profileMenuDesc": "Finden Sie Ihr Profil und Ihre persönlichen Einstellungen unter <b>Mein Konto.</b>",
      "personalTitle": "Zugriff auf alles, was Sie brauchen",
      "personalDesc": "<b>Mein Konto</b> umfasst Ihr Profil, Einstellungen, Meeting-Transkripte und mehr.",
      "adminCenterTitle": "Organisationseinstellungen im Admin Center finden",
      "adminCenterDesc": "Ihr neues <b>Admin Center</b> ermöglicht es Ihnen, Produkte zu konfigurieren und Einstellungen für Ihre gesamte Organisation anzupassen.",
      "adminMenuForTitle": "Das Admin Center professionell nutzen",
      "adminMenuForAccountSettings": "Über <b>Einstellungen</b> greifen Sie auf die Standard-Produkteinstellungen für alle in Ihrer Organisation zu.",
      "adminMenuForContentManagementItem": "Unter <b>Inhaltsverwaltung</b> verwalten Sie alle von Benutzern erstellten Inhalte.",
      "adminMenuForConfigureProductsItem": "Unter <b>Produktkonfiguration</b> richten Sie Ihre Produkte ein und erledigen Admin-Aufgaben.",
      "adminMenuForNoItems": "Im neuen Admin Center können Sie Kontoeinstellungen und Produkte einfacher aufrufen und verwalten. Sie können außerdem beliebige Elemente anheften, um schneller darauf zuzugreifen.",
      "tryNewExperience": "Neue Oberfläche ausprobieren",
      "tryNewExperienceDetail": "Probieren Sie es aus! Sie können jederzeit zu dieser klassischen Oberfläche zurückkehren.",
      "tryNewExperienceTitle": "Neues Erscheinungsbild für Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Alle Rechte vorbehalten.",
    "terms": "Nutzungsbedingungen",
    "privacy": "Datenschutz",
    "trust_center": "Trust Center",
    "acceptable_use_guidelines": "Richtlinien zur akzeptablen Nutzung",
    "legal": "Rechtliches",
    "do_not_sell_my_personal_information": "Ihre Datenschutzoptionen",
    "cookie_preferences": "Cookie-Einstellungen",
    "pricing": "Pläne und Preise",
    "feedback": "Feedback",
    "contact_us": "Kontakt"
  },
  "termChange": {
    "changeTerm": {
      "title": "Vereinbarung zur Änderung der Verlängerungslaufzeit",
      "quoteNumbers": "Geänderte(s) Bestellformular(e) – {0}",
      "content1": "Mit der Annahme dieser Bedingungen erklärt sich der Kunde damit einverstanden, die bestehende Verlängerungslaufzeit des Abonnements für alle Bestellformulare zwischen Zoom Communications, Inc. („Zoom“) und dem Kunden zu ändern, indem die vereinbarte Laufzeit von einer monatlichen Verlängerung auf eine {0} umgestellt wird. Im Gegenzug für diese Verpflichtung erklärt sich Zoom bereit, die aktuellen Preise des Kunden für die Dauer der ersten neuen Verlängerungslaufzeit beizubehalten.",
      "content2": "Der Kunde versteht, dass die neue Verlängerungslaufzeit von {0} gilt, sobald der Kunde unten auf „Ich akzeptiere“ klickt, und dass die neue Verlängerungslaufzeit am Tag nach dem Ende der aktuellen monatlichen Verlängerungslaufzeit des Kunden beginnt. Diese neue Verlängerungslaufzeit gilt für alle derzeit mit Zoom gültigen Bestellformulare, und alle zukünftigen Verlängerungslaufzeiten unter diesen Bestellformularen haben dieselbe Laufzeitlänge.",
      "content3": "Der Kunde bestätigt, dass die einzige Änderung die Verlängerungslaufzeit betrifft und dass alle übrigen Bedingungen jedes derzeit mit Zoom gültigen Bestellformulars unverändert bleiben und gemäß ihren Bestimmungen weiterhin in vollem Umfang gelten.",
      "content4": "Sie erklären sich ferner damit einverstanden, dass dies eine vertragliche Verpflichtung zwischen dem Kunden und Zoom ist.",
      "agreementText": "Mit dem Klick auf „Ich akzeptiere“ bestätigen Sie, dass Sie berechtigt sind, diese Änderung im Namen des Kunden vorzunehmen, und dass der Kunde den oben genannten Bedingungen zustimmt.",
      "IDecline": "Ablehnen",
      "IAccept": "Ich akzeptiere"
    },
    "unableToChangeTerm": {
      "title": "Verlängerungslaufzeit kann nicht geändert werden",
      "content": "Ihr Konto ist nicht berechtigt, die Verlängerungslaufzeit zu aktualisieren. <a target=\"_blank\" href=\"{0}\">Kontaktieren Sie uns</a>, falls dies ein Fehler ist.",
      "acceptedTitle": "Verlängerungslaufzeit verlängert",
      "acceptedContent": "Sie haben die Verlängerungsbedingungen bereits akzeptiert. Es sind keine weiteren Schritte erforderlich.",
      "GotIt": "Verstanden"
    },
    "termLengthUpdated": "Länge der Verlängerungslaufzeit auf {0} Monate aktualisiert.",
    "termLengthUnchanged": "Laufzeitlänge unverändert.",
    "errorInfo": "Es ist ein Serverfehler aufgetreten. Versuchen Sie es erneut.",
    "x12MonthTerm": "zwölfmonatige (12) Laufzeit",
    "x24MonthTerm": "vierundzwanzigmonatige (24) Laufzeit",
    "x12MonthTermPlural": "zwölf (12) Monate",
    "x24MonthTermPlural": "vierundzwanzig (24) Monate"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Ihr Konto wird am {0} auf die <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">neue Zoom-Weboberfläche</a> aktualisiert.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Aktualisierungszeitpunkt prüfen</a>"
    },
    "completed": {
      "content": "Die neue Zoom-Weboberfläche ist jetzt für alle Benutzer Ihres Kontos aktiv. Benutzer sehen die aktualisierte Oberfläche bei der nächsten Anmeldung."
    }
  }
}
